import { Injectable,NgZone } from '@angular/core';
import { Observable } from 'rxjs';
import { SseService } from './sse.service';
import { HttpClient } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class EmsdashboardService {
  constructor(private _zone: NgZone, private _sseService: SseService, private http: HttpClient) { }
  getServerSentEvent(url): Observable<any> {
    return Observable.create((observer) => {
      const es = this._sseService.getEventSource(url);
      es.onmessage = (event) => {
        this._zone.run(() => observer.next(event));
      };
      es.onerror = (error) => {
        observer.error(error);
      };
    });
  }
getParameterConfig(meterid){
  return this.http.get(`getEmsParameterConfig?meterid=`+meterid);
}
 getKWH(data){
  return this.http.post(`getKWHDATA`,data);
 }
 getMeterCount(deviceid){
   return this.http.get(`getMeterCount?deviceid=`+deviceid);
 }
 getEnergyMeterData(data){
   return this.http.post(`getEnergyMeterData`,data);
 }
 getCurrentMonthKwh(userid){
  return this.http.post(`getCurrentMonthKwh`,userid);
}
meterStatus(meters){
  return this.http.post(`meterStatus`,meters);
}
getemsmonthdata(meters){
  return this.http.post(`getemsmonthdata`,meters);
}
alertSections(meters){
  return this.http.post(`alertSections`,meters);
}
getMonthwiseAveragePF(userid){
  return this.http.post(`getMonthwiseAveragePF`,userid);
}
getMonthwiseConsumptionData(userid){
  return this.http.post(`getMonthwiseConsumptionData`,userid);
}
getDailyConsumptionData(userid){
  return this.http.post(`getDailyConsumptionData`,userid);
}
getAlertData(body){
  return this.http.post(`getAlertData`,body);
}
gethoverdatatree(body){
  return this.http.post(`gethoverdatatree`,body);
}
getAlertDataReport(body){
  return this.http.post(`getAlertDataReport`,body);
}
getCurrentAndPreviousMonthsKwhData(body){
  return this.http.post(`getCurrentAndPreviousMonthsKwhData`,body);
}
getCurrentAndPreviousDaysKwhData(body){
  return this.http.post(`getCurrentAndPreviousDaysKwhData`,body);
}
getTotalMonthlyData(body){
  return this.http.post(`getTotalMonthlyData`,body);
}
getLastUpdatedAlert(body){
  return this.http.post(`getLastUpdatedAlert`,body);
}
getEMSLiveAlerts(body){
  return this.http.post(`getEMSLiveAlerts`,body);
}
getLastUpdatedEMSAlertsData(body){
  return this.http.post(`getLastUpdatedEMSAlertsData`,body);
}
getLiveEMSAlertsData(body){
  return this.http.post(`getLiveEMSAlertsData`,body);
}
getIndividualMeterMonthData(body){
  return this.http.post(`getIndividualMeterMonthData`,body);
}
getIndividualEnergyMeterAlerts(body){
  return this.http.post(`getIndividualEnergyMeterAlerts`,body);
}
getEnergyMeterIds(body){
  return this.http.post(`getEnergyMeterIds`,body);
}
}